import { isBefore, isValid } from 'date-fns';
import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';
import { formatInTimeZone } from 'date-fns-tz';

export const isDateInThePast = (date?: string): boolean =>
  !!(date && isValid(legacyParse(date)) && isBefore(legacyParse(date), new Date()));

export const getFormattedDateAndUtcParts = ({
  startingAt,
  timeZone,
  endingAt,
  withTime,
}: {
  startingAt?: string;
  timeZone?: string;
  endingAt?: string;
  withTime?: boolean;
}) => {
  if (!startingAt || !timeZone) {
    return {
      datePart: '',
      utcPart: '',
    };
  }

  const startingAtFormat = withTime
    ? convertTokens('dddd MMMM DD, YYYY, h:mm A')
    : convertTokens('ddd MMMM DD, YYYY');

  const endingAtFormat = withTime ? convertTokens('h:mm A') : convertTokens('ddd MMMM DD, YYYY');

  const startingAtString = formatInTimeZone(startingAt, timeZone, startingAtFormat);
  const endingAtString = endingAt
    ? `${formatInTimeZone(endingAt, timeZone, endingAtFormat)}`
    : 'Ongoing';

  const sanitizedTimeZone = timeZone.split('_').join(' ');

  const utc = `UTC${formatInTimeZone(startingAt, timeZone, 'xxx')}`;
  const utcPart = `(${utc}) ${sanitizedTimeZone}`;

  return {
    datePart: `${startingAtString} - ${endingAtString}`,
    utcPart,
  };
};
